import React from "react";
import { TouchableOpacity, Text, StyleSheet } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import withErrorBoundary from "../../utility/auth/withErrorBoundary";

type CreateGroupButtonProps = {
  arrListData: any[];
  onCreateGroupChat: (selectedUserIDs: string[]) => void;
  onContactClose: () => void;
};

const CreateGroupButton: React.FC<CreateGroupButtonProps> = ({
  arrListData,
  onCreateGroupChat,
  onContactClose,
}) => {
  const handleCreateGroupChat = () => {
    const selectedUserIDs: string[] = arrListData
      .reduce((acc, section) => {
        const selectedItems = section.users.filter(
          (item) => item.isSelected === 1
        );
        return acc.concat(selectedItems);
      }, [])
      .map((item) => item.userID.toString());
    onCreateGroupChat(selectedUserIDs);
    onContactClose();
  };

  return (
    <TouchableOpacity onPress={handleCreateGroupChat} style={styles.button}>
      <Text style={[AppFontStyle.BOLD_ANYBODY_14, styles.buttonText]}>
        Create
      </Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    position: "absolute",
    right: 40,
    borderWidth: 1.8,
    borderColor: "#51AF07",
    backgroundColor: "#51AF07",
    borderRadius: 10,
    height: 30,
    justifyContent: "center",
    alignItems: "center",
  },
  buttonText: {
    color: AppColors.white,
    marginVertical: 7,
    marginHorizontal: 10,
  },
});

export default withErrorBoundary(CreateGroupButton);
